// extracted by mini-css-extract-plugin
var _1 = "ScaledAnswer_item__6d915";
var _2 = "ScaledAnswer_label__de7ef";
var _3 = "ScaledAnswer_mask__46a49";
var _4 = "ScaledAnswer_textInner__17cc6";
export { _1 as "item", _2 as "label", _3 as "mask", _4 as "textInner" }
